import type { InternalSkuStatusResponse } from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

/**
 * Epic #898 P6 (#910): read the 24h status snapshot + 5-minute buckets
 * for one SKU. Proxied by ops-api to platform
 * `GET /internal/status/skus/:skuId` (#906) — the SKU detail sparkline
 * data source. `snapshot` is null before the first rollup saw the SKU.
 */
export function getSkuStatus(
  skuId: string,
  fetchImpl: typeof fetch = fetch,
  signal?: AbortSignal,
): Promise<InternalSkuStatusResponse> {
  return opsApiRequest<InternalSkuStatusResponse>(
    `/v1/ops/sku-status/${encodeURIComponent(skuId)}`,
    { signal },
    fetchImpl,
  );
}
